import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom'; 
import jsCookie from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faUser } from '@fortawesome/free-solid-svg-icons';

import ViewDashboard from '../component/ViewDashboard';
import ViewBranch from '../component/ViewBranch';
import ViewHub from '../component/ViewHub';
import CreateHub from '../component/CreateHub';
import CreateBranch from '../component/CreateBranch';
import ViewCustomer from '../component/ViewCustomer';
import CreateCustomer from '../component/CreateCustomer';
import ViewDelivery from '../component/ViewDelivery';
import CreateOutfordelivery from '../component/CreateOutfordelivery';
import CompleteDelivery from '../component/CompleteDelivery';
import ViewDispute from '../component/ViewDispute';
import ViewCreatedManifest from '../component/ViewCreatedManifest';
import ViewReciebleManifest from '../component/ViewReciebleManifest';
import CreateManifest from '../component/CreateManifest';
import ViewSetting from '../component/ViewSetting';
import ViewShipment from '../component/ViewShipmentAdmin';
import CreateShipment from '../component/CreateShipment';
import ViewStaff from '../component/ViewStaff';
import CreateStaff from '../component/CreateStaff';
import ViewTicket from '../component/ViewTicket';
import ViewVendor from '../component/ViewVendor';
import CreateVendor from '../component/CreateVendor';
import './AdminHome.css';
import logo from '../images/logo.png'



const ViewHome = () => {
  const navigate = useNavigate();
  const [currentDateTime, setCurrentDateTime] = useState("");
  const [activeComponent, setActiveComponent] = useState("Dashboard"); // 
  const [showShipmentOptions, setShowShipmentOptions] = useState(false);
  const [showManifestOptions, setShowManifestOptions] = useState(false);
  const [showCustomerOptions, setShowCustomerOptions] = useState(false);
  const [showVendorOptions, setShowVendorOptions] = useState(false);
  const [showBranchOptions, setShowBranchOptions] = useState(false);
  const [showStaffOptions, setShowStaffOptions] = useState(false);
  const [showOutfordeliveryOptions, setShowOutfordeliveryOptions] = useState(false);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const token = jsCookie.get('auth_token');  // Get the cookie
  
    console.log('Token from cookie:', token); // Log token to check if it's available
  
    if (!token) {
      navigate('/login');  // If no token, redirect to login
      return;
    }
  
    try {
      const decodedToken = jwtDecode(token);  // Use jwt-decode to decode the token
      console.log('Decoded Token:', decodedToken); // Log decoded token
  
      if (decodedToken.role === 'ADMIN') {
        setRole('ADMIN');
      } else if (decodedToken.role === 'HUB-HEAD') {
        setRole('HUB-HEAD');
        navigate('/branch-home');
      } else if (decodedToken.role === 'BRANCH-INCHARGE') {
        setRole('BRANCH-INCHARGE');
        navigate('/branch-home');
      } else if (decodedToken.role === 'STAFF') {
        setRole('STAFF');
        navigate('/branch-home');
      } else if (decodedToken.role === 'DRIVER') {
        setRole('DRIVER');
        navigate('/branch-home');
      } else {
        navigate('/login');  // Redirect if role is invalid
      }
    } catch (error) {
      console.error('Token decoding failed', error);
      navigate('/login');  // Redirect if the token is invalid or can't be decoded
    }
  
    const updateDateTime = () => {
      const now = new Date();
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      setCurrentDateTime(now.toLocaleString("en-GB", options)); // Adjust locale as needed
    };
  
    updateDateTime();
    const timer = setInterval(updateDateTime, 1000); // Updates every second
    return () => clearInterval(timer); // Cleanup interval on component unmount
  }, [navigate]);

  if (role === 'BRANCH') {
    return null; // Return nothing while redirecting to BranchHome
  }

  const renderComponent = () => {
    switch (activeComponent) {
      case "ViewDashboard":
        return <ViewDashboard />;
      case "ViewShipment":
        return <ViewShipment />;
      case "CreateShipment":
        return <CreateShipment />;
      case "CreateManifest":
        return <CreateManifest />;
      case "ViewCreatedManifest":
        return <ViewCreatedManifest />;
      case "ViewReciebleManifest":
        return <ViewReciebleManifest />;
      case "ViewCustomer":
        return <ViewCustomer />;
      case "CreateCustomer":
        return <CreateCustomer />;
      case "ViewVendor":
        return <ViewVendor />;
      case "CreateVendor":
        return <CreateVendor />;
      case "ViewHub":
        return <ViewHub />;
      case "CreateHub":
        return <CreateHub />;
      case "CreateBranch":
        return <CreateBranch />;
      case "ViewBranch":
        return <ViewBranch />;
      case "ViewStaff":
        return <ViewStaff />;
      case "CreateStaff":
        return <CreateStaff />;
      case "ViewDelivery":
        return <ViewDelivery />;
      case "CreateOutfordelivery":
        return <CreateOutfordelivery />;
      case "CompleteDelivery":
        return <CompleteDelivery />;
      case "ViewTicket":
        return <ViewTicket />;
      case "ViewDispute":
        return <ViewDispute />;
      case "ViewSetting":
        return <ViewSetting />;
      default:
        return <ViewDashboard />;
    }
  };
  
  return (
    <div className="admin-home">
      <div className="sidebar">
        <div className="logocontainer">
          <img src={logo} className='logo'/>
        </div>
        <ul className="sidebar-menu">
          <li onClick={() => setActiveComponent("ViewDashboard")}>Dashboard</li>
          <li 
            onClick={() => setShowShipmentOptions(!showShipmentOptions)} // Toggle Shipment options
            className={showShipmentOptions ? 'active' : ''}
          >
            Shipment
          </li>
          {showShipmentOptions && ( // Conditionally render Shipment options
            <div className="shipment-options" style={{padding:'5px'}}>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("CreateShipment")}>Create Shipment</li>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("ViewShipment")}>View All Shipments</li>
            </div>
          )}
          <li 
            onClick={() => setShowManifestOptions(!showManifestOptions)} // Toggle Manifest options
            className={showManifestOptions ? 'active' : ''}
          >Manifest</li>
          {showManifestOptions && ( // Conditionally render Manifest options
            <div className="shipment-options" style={{padding:'5px'}}>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("CreateManifest")}>Create Manifest</li>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("ViewCreatedManifest")}>View All Created Manifest</li>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("ViewReciebleManifest")}>View All Recieble Manifest</li>
            </div>
          )}
          <li 
            onClick={() => setShowCustomerOptions(!showCustomerOptions)} // Toggle Customer options
            className={showCustomerOptions ? 'active' : ''}
          >Customer</li>
          {showCustomerOptions && ( // Conditionally render Customer options
            <div className="shipment-options" style={{padding:'5px'}}>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("CreateCustomer")}>Create Customer</li>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("ViewCustomer")}>View All Customer</li>
            </div>
          )}
          <li 
            onClick={() => setShowVendorOptions(!showVendorOptions)} // Toggle Vendor options
            className={showVendorOptions ? 'active' : ''}
          >Vendor</li>
          {showVendorOptions && ( // Conditionally render Vendor options
            <div className="shipment-options" style={{padding:'5px'}}>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("CreateVendor")}>Create Vendor</li>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("ViewVendor")}>View All Vendor</li>
            </div>
          )}
          <li 
            onClick={() => setShowBranchOptions(!showBranchOptions)} // Toggle Branch options
            className={showBranchOptions ? 'active' : ''}
          >HUB / Branch</li>
          {showBranchOptions && ( // Conditionally render Branch options
            <div className="shipment-options" style={{padding:'5px'}}>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("CreateHub")}>Create HUB </li>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("CreateBranch")}>Create Branch </li>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("ViewHub")}>View All HUB</li>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("ViewBranch")}>View All Branch</li>
            </div>
          )}
          <li 
            onClick={() => setShowStaffOptions(!showStaffOptions)} // Toggle Staff options
            className={showStaffOptions ? 'active' : ''}
          >Staff</li>
          {showStaffOptions && ( // Conditionally render Staff options
            <div className="shipment-options" style={{padding:'5px'}}>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("CreateStaff")}>Create Staff</li>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("ViewStaff")}>View All Staff</li>
            </div>
          )}
          <li 
            onClick={() => setShowOutfordeliveryOptions(!showOutfordeliveryOptions)} // Toggle Outfordelivery options
            className={showOutfordeliveryOptions ? 'active' : ''}
          >Out for delivery</li>
          {showOutfordeliveryOptions && ( // Conditionally render Outfordelivery options
            <div className="shipment-options" style={{padding:'5px'}}>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("CreateOutfordelivery")}>Create Outfordelivery</li>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("ViewDelivery")}>View All Outfordelivery</li>
              <li style={{fontSize:'15px'}} onClick={() => setActiveComponent("CompleteDelivery")}>Complete Delivery</li>
            </div>
          )}
          <li onClick={() => setActiveComponent("Ticket")}>Support Tickets</li>
          <li onClick={() => setActiveComponent("Dispute")}>Raise a Dispute</li>
          <li onClick={() => setActiveComponent("Setting")}>Settings</li>
          <li onClick={() => alert("Logging out...")}>Logout</li>
        </ul>
      </div>
      <div className="content">
        <div className="header">
          <div className="column1">
            <div className="row">
              <div className="profilepic">
                <FontAwesomeIcon icon={faUser} className="header-icon" />
                </div>
              <div className="userdetail">
                <p>Welcome, <br/>
                <b>Username</b> <br/>
                (User Type)</p>
              </div>
            </div> 
            <div className="date">
              <p>Date: {currentDateTime}</p>
            </div>
          </div>
          <div className="column2">
            <button className="header-button">Create Shipment</button>
          </div>
          <div className="column3">
            <button className="header-button">Create Manifest</button>
          </div>
          <div className="column4">
            <button className="header-button">Complete Shipment</button><br/>
            <FontAwesomeIcon icon={faBell} className="pic-icon" />
          </div>
        </div>
        {renderComponent()}
      </div>
    </div>
  );
};

export default ViewHome;
